export { bus, busEvents } from '@/composables/eventBus';
import type {
  $track,
  $modal,
  $api,
  $toast,
  $format,
  $platformConfig,
  $helpLink,
  $route,
  $router,
  $t,
  $i18next,
  ToBeFixed,
} from '@/vite-env';
import api from '@/helpers/api';
import { toast } from 'vue-sonner';
import { track } from '@/helpers/tracker';
import { format } from '@/helpers/format-plugin';
import i18next from '@/helpers/i18n';
import { modalManager } from '@/helpers/modal-manager';
import { $platformConfig as platformConfigPlugin } from '@/helpers/platform-config-plugin';

export {
  useRoute,
  useRouter,
  onBeforeRouteUpdate,
  onBeforeRouteLeave,
} from 'vue-router';

type Proxy = {
  $track: $track;
  $modal: $modal;
  $toast: $toast;
  $api: $api;
  $format: $format;
  $route: $route;
  $router: $router;
  $platformConfig: $platformConfig;
  $helpLink: $helpLink;
  $t: $t;
  $i18next: $i18next;
  $slots: ToBeFixed;
};

export const useApi = () => api;
export const useTrack = () => track;
export const useModal = <T = unknown>() =>
  modalManager as Proxy['$modal'] & { context: T };
export const useToast = () => toast;
export const useFormat = () => format;
export const usePlatformConfig = () => platformConfigPlugin as $platformConfig;
export const useTranslation = () => ({
  t: i18next.t.bind(i18next),
  i18next,
});
